import axios from 'axios'
import Router from 'vue-router'
// import 'er-console'
// import router from './router'

// import { Toast } from 'vant'
import Vue from 'vue'
Vue.use(Router)
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'



// WEBPACK FOOTER //
// ./src/common/http.js